$(document).ready(function () {
  // =============== collection page slider JS Start ================
  $(".collection-slider").slick({
    slidesToShow: 8,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 4.5, slidesToScroll: 1 },
      },
    ],
  });
  // ============== collection page slider JS End ================

 // ============== Special Product JS Start ================

    //  Checkbox  show/hide  
    // $(document).on("click", ".special-gift-info", function () {
    //   const checkbox = $(this).find(".special-gift-checkbox");
    //   checkbox.prop("checked", !checkbox.prop("checked"));
    //   const cartGiftBlock = $(this).closest(".cart-special-gift");

    //     if (checkbox.is(":checked")) {
    //       cartGiftBlock.addClass("active");
    //     } else {
    //       cartGiftBlock.removeClass("active"); 
    //     }
    // });

    $(document).on("change", ".special-gift-checkbox", function () {
      const checkbox = $(this);
      const cartGiftBlock = checkbox.closest(".cart-special-gift");
      if (checkbox.is(":checked")) {
        cartGiftBlock.addClass("active");
      } else {
        cartGiftBlock.removeClass("active");
      }
    });

    
    // Quantity  button logic
    $(document).on("click", ".qty-btn.plus", function (e) {
      e.preventDefault();
      const $input = $(this).closest(".quantity-stepper").find(".qty-input");
      let currentVal = parseInt($input.val());
      $input.val(currentVal + 1); // Increase value by 1
    });
    
    
    $(document).on("click", ".qty-btn.minus", function (e) {
      e.preventDefault();
      const $input = $(this).closest(".quantity-stepper").find(".qty-input");
      let currentVal = parseInt($input.val());
      if (currentVal > 1) {
        $input.val(currentVal - 1); 
      }
    });
    
    // Add special gift product to cart via AJAX
    $(document).on("click", ".special-gift-ajax-btn", function () {
      var variantId = $(this).attr("data-variant-id"); // Get selected variant ID
      var gift_qty = $(this).closest(".gift-product-content").find(".qty-input").val(); 
      var giftInputName = $(this).closest(".gift-product-content").find('.gift-input-value').attr("name"); 
      
      //get item data
      var parent_item_id = $(this).closest(".cart-item").attr("data-item-id");
      var parent_item_qty = $(this).closest(".cart-item").attr("data-item-qty");

      AddToCart(variantId, gift_qty, $(this),giftInputName);
    });
  
    function AddToCart(variantId, gift_qty, btn,giftInputName) {
      let cartDrawer = document.querySelector("cart-drawer");
      let sectionsToRender = cartDrawer.getSectionsToRender().map((section) => section.id);
      let sectionsUrl = window.location.pathname;
      var giftInputValue = $(btn).closest(".gift-product-content").find('.gift-input-value').val();  
      let propertiesObj = {};
      propertiesObj[giftInputName] = giftInputValue;
      
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          id: variantId,
          quantity: gift_qty,
          properties: propertiesObj, 
          sections: sectionsToRender,
          sections_url: sectionsUrl,
        },
        dataType: "json",
        success: function (response) {
          // Re-render cart drawer contents after successful addition
          cartDrawer.renderContents(response);
        },
        error: function (xhr, status, error) {
          // Log any errors to the console
          console.error("AJAX error:", status, error, xhr.responseText);
        },
      });
    }

  // ============== Special Product JS End ================

  // ============= START: Featured Product Section ============= //
    $(function () {
      $('.featured-products-list').each(function () {
        var $slider = $(this);
        var $section = $slider.closest('.featured-collection-v2');

        var isFeaturePieces = $section.hasClass('feature-pieces-section');

        function updateSliderInfo(slick, currentSlide) {
          currentSlide = currentSlide || 0;

          var slidesToShow = slick.options.slidesToShow;
          var totalSlides = slick.slideCount;
          var totalPages = Math.max(
            Math.ceil(totalSlides - slidesToShow + 1),
            1
          );
          var currentPage = currentSlide + 1;

          if (totalPages <= 1) {
            $section.find('.featured-slider-footer').hide();
          } else {
            $section.find('.featured-slider-footer').show();

            $section.find('.featured-pagination .current').text(currentPage);
            $section.find('.featured-pagination .total').text(totalPages);

            var progress = (currentPage / totalPages) * 100;
            $section
              .find('.featured-progress-bar')
              .css('width', progress + '%');
          }
        }

        $slider.on('init', function (event, slick) {
          updateSliderInfo(slick, 0);
        });

        $slider.on('afterChange', function (event, slick, currentSlide) {
          updateSliderInfo(slick, currentSlide);
        });

        $slider.on('breakpoint', function (event, slick) {
          updateSliderInfo(slick, slick.currentSlide);
        });

        $slider.on('reInit', function (event, slick) {
          updateSliderInfo(slick, slick.currentSlide);
        });

        $slider.slick({
          slidesToShow: 4.55,
          slidesToScroll: 1,
          infinite: false,
          speed: 500,
          arrows: true,
          dots: false,
          slidesOffsetAfter: 100,
          slidesOffsetBefore: 100,

          appendArrows: $section.find('.featured-slider-arrows'),

          prevArrow: `
            <button type="button" class="slick-prev custom-arrow">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path
                  d="M15 5L8 12L15 19"
                  stroke="#475F3F"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          `,

          nextArrow: `
            <button type="button" class="slick-next custom-arrow">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path
                  d="M9 5L16 12L9 19"
                  stroke="#475F3F"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          `,

          responsive: [
            {
              breakpoint: 1480,
              settings: {
                slidesToShow: 3.55
              }
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 990,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 768,
              settings: {
                // Feature Pieces: 1.75 | Other sections: 2.05
                slidesToShow: isFeaturePieces ? 1.75 : 2.05
              }
            }
          ]
        });
      });
    });
  // ============= END: Featured Product Section ============= //

  // ============= START: Video Slider Section ============= //
    (function(){
      var viewport=document.getElementById('UgcMarquee');
      if(!viewport)return;
      var track=viewport.querySelector('.ugc-marquee__track');
      var cards=Array.prototype.slice.call(viewport.querySelectorAll('[data-ugc-card]'));
      if(!track||!cards.length)return;
      var setLength=cards.length/3;
      var currentIndex=setLength;
      var isAnimating=false;
      var animationDuration=450;
      var autoSlideDelay=2000;
      var autoSlideTimer=null;
      var scrollbarProgress=viewport.parentElement.querySelector('.ugc-marquee__scrollbar-progress');
      var isDragging=false;
      var dragStartX=0;
      var dragCurrentX=0;
      var dragStartOffset=0;
      var dragMoved=false;
      var isVideoPlaying=false;
      var isHovered=false;
      function getCenterOffset(index){
        var card=cards[index];
        if(!card)return 0;
        return card.offsetLeft+(card.offsetWidth/2)-(viewport.clientWidth/2);
      }
      function updateCenterCard(index){
        cards.forEach(function(card,i){
          card.classList.toggle('center',i===index);
          card.classList.toggle('previous',i===index-1);
          card.classList.toggle('next',i===index+1);
        });
      }
      function updateProgress(){
        if(scrollbarProgress&&setLength>1){
          var logicalIndex=(currentIndex-setLength)%setLength;
          if(logicalIndex<0)logicalIndex+=setLength;
          scrollbarProgress.style.width=((logicalIndex/(setLength-1))*100)+'%';
        }
      }
      function goTo(index,animate){
        if(!cards[index])return;
        currentIndex=index;
        var offset=getCenterOffset(index);
        track.style.transition=animate?'transform '+animationDuration+'ms ease':'none';
        updateCenterCard(index);
        track.style.transform='translate3d('+(-offset)+'px,0,0)';
        updateProgress();
      }
      function hasPlayingVideo(){
        var playing=false;
        viewport.querySelectorAll('.ugc-card__media video').forEach(function(video){
          if(!video.paused&&!video.ended){
            playing=true;
          }
        });
        return playing;
      }
      function resetAutoSlide(){
        clearTimeout(autoSlideTimer);
        if(isVideoPlaying||isDragging||isAnimating||isHovered)return;
        autoSlideTimer=setTimeout(function(){
          if(!isVideoPlaying&&!isDragging&&!isAnimating&&!isHovered){
            nextSlide();
          }
        },autoSlideDelay);
      }
      function nextSlide(){
        if(isAnimating||isVideoPlaying||isHovered)return;
        clearTimeout(autoSlideTimer);
        isAnimating=true;
        var targetIndex=currentIndex+1;
        goTo(targetIndex,true);
        setTimeout(function(){
          if(targetIndex>=setLength*2){
            targetIndex-=setLength;
            goTo(targetIndex,false);
          }
          isAnimating=false;
          if(!isVideoPlaying&&!isDragging&&!isHovered){
            resetAutoSlide();
          }
        },animationDuration);
      }
      function previousSlide(){
        if(isAnimating||isVideoPlaying)return;
        clearTimeout(autoSlideTimer);
        isAnimating=true;
        var targetIndex=currentIndex-1;
        goTo(targetIndex,true);
        setTimeout(function(){
          if(targetIndex<setLength){
            targetIndex+=setLength;
            goTo(targetIndex,false);
          }
          isAnimating=false;
          if(!isVideoPlaying&&!isDragging&&!isHovered){
            resetAutoSlide();
          }
        },animationDuration);
      }
      function handleDragEnd(){
        if(!isDragging)return;
        isDragging=false;
        viewport.classList.remove('is-dragging');
        if(isVideoPlaying){
          goTo(currentIndex,true);
          return;
        }
        var diff=dragCurrentX-dragStartX;
        var threshold=Math.max(40,viewport.clientWidth*0.08);
        if(Math.abs(diff)>=threshold){
          if(diff<0){
            nextSlide();
          }else{
            previousSlide();
          }
        }else{
          goTo(currentIndex,true);
          resetAutoSlide();
        }
        dragMoved=false;
      }
      function initialize(){
        var initialCenterIndex=0;
        var viewportCenter=viewport.getBoundingClientRect().left+(viewport.clientWidth/2);
        var minDistance=Infinity;
        cards.slice(0,setLength).forEach(function(card,index){
          var rect=card.getBoundingClientRect();
          var cardCenter=rect.left+(rect.width/2);
          var distance=Math.abs(cardCenter-viewportCenter);
          if(distance<minDistance){
            minDistance=distance;
            initialCenterIndex=index;
          }
        });
        currentIndex=setLength+initialCenterIndex;
        goTo(currentIndex,false);
        resetAutoSlide();
      }
      var prevButton=viewport.querySelector('.ugc-marquee__arrow--prev');
      var nextButton=viewport.querySelector('.ugc-marquee__arrow--next');
      if(prevButton){
        prevButton.addEventListener('click',function(e){
          e.preventDefault();
          if(isVideoPlaying)return;
          previousSlide();
        });
      }
      if(nextButton){
        nextButton.addEventListener('click',function(e){
          e.preventDefault();
          if(isVideoPlaying)return;
          nextSlide();
        });
      }
      viewport.addEventListener('mouseenter',function(){
        isHovered=true;
        clearTimeout(autoSlideTimer);
      });
      viewport.addEventListener('mouseleave',function(){
        isHovered=false;
        if(!isVideoPlaying&&!isDragging&&!isAnimating){
          resetAutoSlide();
        }
      });
      viewport.addEventListener('mousedown',function(e){
        if(e.target.closest('.ugc-marquee__arrow')||e.target.closest('.ugc-card__play')||e.target.closest('.ugc-card__mute'))return;
        if(isAnimating||isVideoPlaying)return;
        clearTimeout(autoSlideTimer);
        isDragging=true;
        dragMoved=false;
        dragStartX=e.clientX;
        dragCurrentX=e.clientX;
        dragStartOffset=getCenterOffset(currentIndex);
        track.style.transition='none';
        viewport.classList.add('is-dragging');
      });
      window.addEventListener('mousemove',function(e){
        if(!isDragging||isVideoPlaying)return;
        dragCurrentX=e.clientX;
        var diff=dragCurrentX-dragStartX;
        if(Math.abs(diff)>5){
          dragMoved=true;
        }
        var newOffset=dragStartOffset-diff;
        track.style.transform='translate3d('+(-newOffset)+'px,0,0)';
      });
      window.addEventListener('mouseup',function(){
        handleDragEnd();
      });
      viewport.addEventListener('touchstart',function(e){
        if(e.target.closest('.ugc-marquee__arrow')||e.target.closest('.ugc-card__play')||e.target.closest('.ugc-card__mute'))return;
        if(isAnimating||isVideoPlaying)return;
        clearTimeout(autoSlideTimer);
        isDragging=true;
        dragMoved=false;
        dragStartX=e.touches[0].clientX;
        dragCurrentX=e.touches[0].clientX;
        dragStartOffset=getCenterOffset(currentIndex);
        track.style.transition='none';
        viewport.classList.add('is-dragging');
      },{passive:true});
      viewport.addEventListener('touchmove',function(e){
        if(!isDragging||isVideoPlaying)return;
        dragCurrentX=e.touches[0].clientX;
        var diff=dragCurrentX-dragStartX;
        if(Math.abs(diff)>5){
          dragMoved=true;
        }
        var newOffset=dragStartOffset-diff;
        track.style.transform='translate3d('+(-newOffset)+'px,0,0)';
        if(Math.abs(diff)>10){
          e.preventDefault();
        }
      },{passive:false});
      viewport.addEventListener('touchend',function(){
        handleDragEnd();
      });
      viewport.addEventListener('touchcancel',function(){
        handleDragEnd();
      });
      window.addEventListener('resize',function(){
        if(!isAnimating&&!isDragging){
          goTo(currentIndex,false);
          resetAutoSlide();
        }
      });
      initialize();
      viewport.querySelectorAll('.ugc-card').forEach(function(card){
        var video=card.querySelector('.ugc-card__media video');
        var playButton=card.querySelector('.ugc-card__play');
        var muteButton=card.querySelector('.ugc-card__mute');
        if(!video)return;
        var isAutoplay=video.hasAttribute('autoplay');
        video.setAttribute('playsinline','');
        if(isAutoplay){
          video.muted=true;
          video.setAttribute('muted','');
        }else{
          video.muted=false;
          video.removeAttribute('muted');
        }
        if(isAutoplay){
          if(playButton){
            playButton.style.display='none';
          }
          if(muteButton){
            muteButton.style.display='none';
          }
          function startAutoplay(){
            video.muted=true;
            video.play().then(function(){
              if(playButton){
                playButton.style.display='none';
              }
              if(muteButton){
                muteButton.style.display='flex';
              }
              isVideoPlaying=false;
              if(!isHovered){
                resetAutoSlide();
              }
            }).catch(function(){
              setTimeout(function(){
                if(video.paused&&!isHovered){
                  video.play().then(function(){
                    if(playButton){
                      playButton.style.display='none';
                    }
                    if(muteButton){
                      muteButton.style.display='flex';
                    }
                    isVideoPlaying=false;
                    resetAutoSlide();
                  }).catch(function(){});
                }
              },300);
            });
          }
          if(video.readyState>=2){
            startAutoplay();
          }else{
            video.addEventListener('loadeddata',startAutoplay,{once:true});
            video.addEventListener('canplay',startAutoplay,{once:true});
          }
        }else{
          video.pause();
          video.muted=false;
          video.removeAttribute('muted');
          if(playButton){
            playButton.style.display='';
          }
          if(muteButton){
            muteButton.style.display='none';
          }
        }
        if(playButton){
          playButton.addEventListener('click',function(event){
            event.preventDefault();
            event.stopPropagation();
            if(video.paused){
              video.muted=false;
              video.removeAttribute('muted');
              video.play().catch(function(){});
            }else{
              video.pause();
            }
          });
        }
        if(muteButton){
          muteButton.addEventListener('click',function(event){
            event.preventDefault();
            event.stopPropagation();
            if(!isAutoplay)return;
            if(video.paused)return;
            if(video.muted){
              viewport.querySelectorAll('.ugc-card__media video').forEach(function(otherVideo){
                if(otherVideo!==video&&otherVideo.hasAttribute('autoplay')){
                  otherVideo.muted=true;
                  var otherMuteButton=otherVideo.closest('.ugc-card')?.querySelector('.ugc-card__mute');
                  if(otherMuteButton){
                    otherMuteButton.setAttribute('aria-pressed','false');
                    otherMuteButton.setAttribute('aria-label','Unmute video');
                  }
                }
              });
              video.muted=false;
              video.removeAttribute('muted');
              muteButton.setAttribute('aria-pressed','true');
              muteButton.setAttribute('aria-label','Mute video');
              isVideoPlaying=true;
              clearTimeout(autoSlideTimer);
            }else{
              video.muted=true;
              video.setAttribute('muted','');
              muteButton.setAttribute('aria-pressed','false');
              muteButton.setAttribute('aria-label','Unmute video');
              isVideoPlaying=false;
              resetAutoSlide();
            }
          });
        }
        video.addEventListener('play',function(){
          if(!isAutoplay){
            isVideoPlaying=true;
            clearTimeout(autoSlideTimer);
            isDragging=false;
            viewport.classList.remove('is-dragging');
            viewport.querySelectorAll('.ugc-card__media video').forEach(function(otherVideo){
              if(otherVideo!==video&&!otherVideo.paused){
                otherVideo.pause();
                otherVideo.currentTime=0;
              }
            });
          }else if(!video.muted){
            isVideoPlaying=true;
            clearTimeout(autoSlideTimer);
          }
          if(playButton){
            playButton.style.display='none';
          }
          if(isAutoplay&&muteButton){
            muteButton.style.display='flex';
          }
          if(!isAutoplay&&muteButton){
            muteButton.style.display='none';
          }
        });
        video.addEventListener('pause',function(){
          if(playButton){
            playButton.style.display=isAutoplay?'none':'';
          }
          if(muteButton){
            muteButton.style.display='none';
          }
          if(isAutoplay){
            if(!video.muted){
              isVideoPlaying=false;
              resetAutoSlide();
            }
          }else{
            setTimeout(function(){
              if(!hasPlayingVideo()){
                isVideoPlaying=false;
                resetAutoSlide();
              }
            },50);
          }
        });
        video.addEventListener('ended',function(){
          if(playButton){
            playButton.style.display=isAutoplay?'none':'';
          }
          if(muteButton){
            muteButton.style.display='none';
          }
          if(!isAutoplay){
            isVideoPlaying=false;
            resetAutoSlide();
          }
        });
        video.addEventListener('click',function(event){
          if(event.target.closest('.ugc-card__mute'))return;
          event.preventDefault();
          event.stopPropagation();
          if(video.paused){
            video.muted=false;
            video.removeAttribute('muted');
            video.play().catch(function(){});
          }else{
            video.pause();
          }
        });
      });
    })();
  // ============= END: Video Slider Section ============= //

  // ============= START: Heritage Slider ============= //
    (function () {
      function initHeritageSlider() {
          var section = document.querySelector( '.heritage-slider-section')
          if (!section) return;
          var slider = section.querySelector('.heritage-slider');
          if (!slider) return;
          var $slider = $(slider);
          if ($slider.hasClass('slick-initialized')) {
          return;
          }
          var totalSlides = $slider.find('.heritage-slider__slide').length;
            $slider.slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: false,
              infinite: true,
              autoplay: true,
              autoplaySpeed: 3000,
              pauseOnHover: false,
              speed: 700,
              fade: true,
              cssEase: 'ease-in-out',
              adaptiveHeight: false,
              swipe: true,
              draggable: true,
              touchMove: true,
              swipeToSlide: true,
              touchThreshold: 10
            });
          function updatePagination(currentSlide) {
          var current = currentSlide + 1;
          var progress = (current / totalSlides) * 100;
          $(section).find('.current-slide').text(current);
          $(section).find('.heritage-slider__progress-bar').css('width', progress + '%');
          }
          updatePagination(0);
          $slider.on(
          'afterChange',
          function (
              event,
              slick,
              currentSlide
          ) {
              updatePagination(currentSlide);
          }
          );
          $(section)
          .find('.heritage-slider__progress')
          .on('click', function (event) {
              var bar = this;
              var rect =
              bar.getBoundingClientRect();
              var clickX =
              event.clientX - rect.left;
              var barWidth =
              rect.width;
              var percentage =
              clickX / barWidth;
              var slideIndex =
              Math.floor(
                  percentage * totalSlides
              );
              if (slideIndex >= totalSlides) {
              slideIndex = totalSlides - 1;
              }
              $slider.slick(
              'slickGoTo',
              slideIndex
              );
          });
      }
      if (
          document.readyState === 'loading'
      ) {
          document.addEventListener(
          'DOMContentLoaded',
          initHeritageSlider
          );
      } else {
          initHeritageSlider();
      }
      document.addEventListener(
          'shopify:section:load',
          function (event) {
          if (
              event.detail.sectionId ===
              '{{ section.id }}'
          ) {
              initHeritageSlider();
          }
          }
      );
    })();
  // ============= END: Heritage Slider ============= //

  // ============== Start: Product Upsell Js ==============
  $('[data-upsell-slider]').each(function () {
    const $slider = $(this);
    const $block = $slider.closest('.product-upsell');
    const $progress = $block.find('[data-upsell-progress]');
    const totalSlides = $slider.find('.product-upsell__slide').length;

    if (totalSlides > 2 && !$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        adaptiveHeight: false,
        responsive: [{
          breakpoint: 544,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 2,
            slidesPerRow: 1,
            adaptiveHeight: false
          }
        }]
      });

      function updateUpsellProgress(currentSlide) {
        if (!$progress.length) return;

        const visibleSlides = 2;
        const totalSteps = Math.max(Math.ceil(totalSlides / visibleSlides), 1);
        const percentage = ((currentSlide + 1) / totalSteps) * 100;

        $progress.css('width', Math.min(percentage, 100) + '%');
      }

      updateUpsellProgress(0);

      $slider.on('afterChange', function (event, slick, currentSlide) {
        updateUpsellProgress(currentSlide);
      });
    }
  });

  $(document).on('click', '[data-upsell-add]', function () {
    const $button = $(this);
    const variantId = $button.attr('data-variant-id');

    if (!variantId) {
      console.error('Upsell variant ID not found.');
      return;
    }

    if ($button.hasClass('is-loading')) return;

    $button.addClass('is-loading');
    $button.find('.product-upsell__add-text').addClass('hidden');
    $button.find('.loading__spinner').removeClass('hidden');

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        items: [{
          id: Number(variantId),
          quantity: 1
        }]
      },
      dataType: 'json',

      success: function (response) {
        console.log('Upsell product added:', response);

        $button.removeClass('is-loading');
        $button.find('.product-upsell__add-text').removeClass('hidden');
        $button.find('.loading__spinner').addClass('hidden');

        $.getJSON('/cart.js', function (cart) {
          const count = cart.item_count;

          $('[data-cart-count]').text(count);
          $('.cart-count-bubble').text(count);
          $('.cart-count-bubble span').text(count);
          $('.cart-count').text(count);
          $('[data-cart-item-count]').text(count);
        });
      },

      error: function (xhr) {
        console.error(
          'Upsell add to cart error:',
          xhr.responseJSON || xhr
        );

        $button.removeClass('is-loading');
        $button.find('.product-upsell__add-text').removeClass('hidden');
        $button.find('.loading__spinner').addClass('hidden');
      }
    });
  });
// ============== End: Product Upsell Js ==============

// ============== Start: Product Customer Review Block Js ==============
  $('.product-customer-reviews').each(function () {
    var $section = $(this);
    var $slider = $section.find('[data-reviews-slider]');
    var $progress = $section.find('[data-reviews-progress]');
    if (!$slider.length) return;
    if ($slider.hasClass('slick-initialized')) return;
    function updateProgress(slick, currentSlide) {
      var totalSlides = slick.slideCount;
      var slidesToShow = slick.options.slidesToShow;
      var visibleSlides = Math.min(
        slidesToShow,
        totalSlides
      );
      var viewedSlides = currentSlide + visibleSlides;
      viewedSlides = Math.min(
        viewedSlides,
        totalSlides
      );
      var percentage = (viewedSlides / totalSlides) * 100;
      percentage = Math.max( 0, Math.min(100, percentage));
      $progress.css( 'width', percentage + '%');
    }
    $slider
    .on('init', function (event, slick) { updateProgress(slick, 0);})
      .on('afterChange', function ( event, slick, currentSlide) {
        updateProgress( slick, currentSlide);
      })
      .slick({
        slidesToShow: 1.65,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        dots: false,
        speed: 500,
        swipeToSlide: false,
        touchThreshold: 10,
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.07,
              slidesToScroll: 1
            }
          }
        ]
      });
  });
// ============== End: Product Customer Review Block Js ==============

// ============= START: PDP Fetured Logo Marquee ============= //
  const featured = document.querySelector('.featured');
  const reviews = document.querySelector('.product-customer-reviews');
  if (!featured || !reviews) return;
  const originalParent = featured.parentNode;
  const originalNextSibling = featured.nextSibling;
  function moveFeatured() {
    if (window.innerWidth <= 989) {
      if (featured.parentNode !== reviews) {
        reviews.appendChild(featured);
      }
    } else {
      if (featured.parentNode !== originalParent) {
        originalParent.insertBefore(featured, originalNextSibling);
      }
    }
  }
  moveFeatured();
  window.addEventListener('resize', moveFeatured);
  // ============= END: PDP Fetured Logo Marquee ============= //


});


